import React from "react";
import { Alert, Box, Container, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import AvgStudyAdherence from "./AvgStudyAdherence";
import StudyAdherenceDistribution from "./StudyAdherenceDistribution";
import AlertsAnalytics from "./AlertsAnalytics";
import ParticipantsMetricsTable from "./ParticipantsMetricsTable";

const StudyAdherenceMonitor: React.FC = () => {
  const [searchParams] = useSearchParams();
  const studyId = searchParams.get("study") || "";

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontWeight: 600 }}
        >
          Study Adherence Monitor
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Monitor adherence and engagement patterns within this study
        </Typography>
      </Box>

      {!studyId && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          Missing study reference in the URL. Please open this page from a study
          dashboard.
        </Alert>
      )}

      {studyId && (
        <>
          <AvgStudyAdherence studyId={studyId} />
          <StudyAdherenceDistribution studyId={studyId} />
          <AlertsAnalytics studyId={studyId} />
          <ParticipantsMetricsTable studyId={studyId} />
        </>
      )}
    </Container>
  );
};

export default StudyAdherenceMonitor;
